<template>
  <div class="container">
    <div class="header">
      <div class="search-container">
        <img src="@/assets/icon/chat-search.svg" class="chat-search" alt="search" height="18" width="17">
        <input type="text" placeholder="ค้นหา" v-model="filterFilter"/>
        <img v-if="filterFilter !== ''" src="@/assets/icon/chat-clear.svg" class="chat-clear" alt="clear" height="13" width="13" @click="clearSearch()">
      </div>
      <div class="filter-container">
        <input type="radio" id="q-1" name="q" value="all" v-model="filterList">
        <label for="q-1" class="text-radio left">
            ทั้งหมด
        </label>
        <input type="radio" id="q-2" name="q" value="inquiry" v-model="filterList">
        <label for="q-2" class="text-radio">
            ผู้สนใจ
        </label>
        <input type="radio" id="q-3" name="q" value="customer" v-model="filterList">
        <label for="q-3" class="text-radio right">
            ลูกค้า
        </label>
      </div>
    </div>
    <div class="chat-list-container">
      <div
        v-for="item in list"
        :key="`lineId-${item.lineId}`"
        @click="!disabled && selectedChat(item)"
        :class="addClass(item.lineId)"
      >
        <img :src="getProfile(item.lineId)" onerror="this.src='https://storage.healthathome.in.th/d6ccee89-635f-4bbc-9f1c-8d1d430ce89a.png'" class="img" alt="profile image" height="60" width="60">
        <div class="info">
          <span v-if="item.patientId === 0" class="chat-paragraph-14-gray" style="margin-bottom: 2px;">N/A</span>
          <span v-else class="chat-paragraph-14-gray" style="margin-bottom: 2px;">P{{item.patientId}}</span>
          <div class="left-right-container" style="margin-bottom: 2px;">
            <div class="chat-header-16-black text">{{item.name}}</div>
            <span class="time chat-paragraph-14-lightgray-2">{{timeToString(item.lastMessage.timestamp)}}</span>
          </div>
          <div class="left-right-container">
            <div class="chat-paragraph-14-lightgray text">{{item.lastMessage.content}}&nbsp;</div>
            <div v-if="item.notification !== 0" class="noti chat-header-14-white">{{item.notification}}</div>
          </div>
        </div>
      </div>
      <el-button v-if="hasMoreChat" style="margin-top: 34px; margin-bottom: 34px; align-self: center;" class="seemore-button" @click="loadMoreChatList()">see more</el-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ChatListModel from '@/model/ChatListModel'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'

export default {
  name: 'ChatContact',
  mixins: [GenericAPIHandler],
  mounted () {
    this.getChatlistInterval()
    window.scroller = this.$refs.scroller
  },
  beforeDestroy () {
    clearTimeout(this.interval)
  },
  watch: {
    async filterList (newVal, oldVal) {
      this.offset = 0
      await this.getChatlist()
    },
    async filterFilter (newVal, oldVal) {
      this.offset = 0
      await this.getChatlist()
    },
    async queryLineId (newVal, oldVal) {
      await this.getChatlist()
      // search Obj of user that have same userId in query string and click select it
      this.info = this.list.filter(function (item) {
        return item.lineId === newVal
      })[0]
      await this.selectedChat(this.info)
    },
  },
  data () {
    return {
      list: [],
      selected: '',
      filterList: 'all',
      filterFilter: '',
      interval: '',
      itemSelected: {},
      offset: 0,
      hasMoreChat: false,
      timer: 15,
    }
  },
  props: {
    id: {
      type: String,
      required: true,
      default: '',
    },
    queryLineId: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    getChatlistInterval () {
      this.getChatlist()
        .then(() => {
          this.interval = setTimeout(() => {
            this.getChatlistInterval()
          }, 5000)
        })
    },
    async getChatlist () {
      try {
        const raw = await this.$api.Chat.list(this.filterList, this.filterFilter, this.offset)
        this.list = raw.list.map((json) => ChatListModel.fromJSON(json))
        this.hasMoreChat = raw.hasMoreChat
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    loadMoreChatList () {
      this.offset += 50
      this.getChatlist()
    },
    async selectedChat (item) {
      this.timer--
      if (item === '') {
        let tmp = this.itemSelected
        this.selected = tmp.lineId

        this.$emit('selectedChat', {
          'info': {
            'lineId': this.id !== '' ? tmp.lineId : '',
            'patientId': tmp.patientId,
            'name': tmp.name,
            'photo': tmp.photo,
          },
          'filter': {
            'list': this.filterList,
            'filter': this.filterFilter,
          },
        })
      } else if (this.list.length !== 0) {
        this.itemSelected = item
        this.selected = item.lineId

        this.$emit('selectedChat', {
          'info': {
            'lineId': item.lineId,
            'patientId': item.patientId,
            'name': item.name,
            'photo': item.photo,
          },
          'filter': {
            'list': this.filterList,
            'filter': this.filterFilter,
          },
        })
      } else {
        this.$emit('selectedChat', {
          'info': {
            'lineId': '',
            'patientId': '',
            'name': '',
            'photo': '',
          },
          'filter': {
            'list': this.filterList,
            'filter': this.filterFilter,
          },
        })
      }
      if (this.timer <= 0) {
        location.reload()
      }
    },
    addClass (lineId) {
      let classList = 'contact-container'
      if (lineId === this.selected) {
        classList += ' selected'
      }
      if (this.disabled) {
        classList += ' disabled'
      }
      return classList
    },
    clearSearch () {
      this.filterFilter = ''
    },
    timeToString (time) {
      const day = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์']
      const mTime = moment(moment(time).format('MM/DD/YY'))
      const mNow = moment(moment().format('MM/DD/YY'))
      const numOfDay = mNow.diff(mTime, 'days')
      if (numOfDay === 0) return moment(time).format('HH:mm')
      else if (numOfDay === 1) return 'เมื่อวาน'
      else if (numOfDay < 8) return day[parseInt(moment(mTime).format('d'))]
      else if (numOfDay > 8) return moment(time).format('DD/MM/YY')
      else return '-'
    },
    getProfile (uid) {
      return this.$api.Chat.profile(uid)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  padding-top: 16px;
  width: 386px;
  height: 100%;
  box-shadow: 2px 3px 15px 2px #dcdfe6;
  margin: 0;
  z-index: 1000;
}

.header {
  height: 112px;
  border-bottom: solid 1px #dcdfe6;
  top: 60px;
}

.total-contact {
  display: flex;
  flex-direction: column;
  height: calc(100% - 114px);
  overflow-y: hidden;
}

.contact-container {
  padding: 16px 20px;
  border-bottom: solid 1px #dcdfe6;
  display: flex;
  flex-direction: row;
  transition: all .08s ease-in-out;

  .img {
    min-width: 60px;
    min-height: 60px;
    border-radius: 30px;
    background: #cbcbcb;
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 20px;
    width: 100%;

    .left-right-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;

      .text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 198px;
      }

      .noti {
        padding: 0.5px 2.5px;
        background-color: #5489FF;
        border-radius: 9px;
        min-width: 23px;
        text-align: center;
      }
    }
  }

  &.selected {
    background: #F1F3F6;

    &.disabled {
      cursor: wait !important;

      &:hover {
        background: #F1F3F6 !important;;
        cursor: wait !important;
      }
    }
  }

  &.disabled {
    cursor: wait !important;

    &:hover {
      background: #FFFFFF !important;;
      cursor: wait !important;
    }
  }

  &:hover {
    background: #f0f2f5;
    cursor: pointer;
  }
}

.header {
  .search-container {
    display: flex;
    justify-content: center;
    margin-bottom: 0;

    input {
      width: 346px;
      height: 40px;
      border-radius: 20px;
      border: solid 1px #dcdfe6;
      background-color: #f0f2f5;
      outline: 0;
      padding: 8px 44px 6px 44px;
      font-family: 'Sukhumvit-Medium';
      font-size: 16px;
      color: #303133;

      &::placeholder {
        font-family: 'Sukhumvit-SemiBold';
        font-size: 16px;
        color: #c0c4cc;
      }
    }

    .chat-search {
      position: fixed;
      top: 87.5px;
      left: 35.5px;
    }

    .chat-clear {
      position: fixed;
      top: 89.5px;
      left: 338px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .filter-container {
    display: flex;
    justify-content: center;
    margin-top: 14px;
    margin-bottom: 14px;
    padding: 0 20px;

    .text-radio {
      flex: 1;
      border: solid 1px #dcdfe6;
      font-family: 'Sukhumvit-SemiBold';
      font-size: 16px;
      color: #606266;
      padding: 7px 0;
      display: flex;
      justify-content: center;
      padding: 10px 0;

      &:hover {
        cursor: pointer;
      }
    }

    .left {
      border-radius: 4px 0 0 4px;
    }

    .right {
      border-radius: 0 4px 4px 0;
    }

    input[type="radio"]{
      visibility:hidden;
      width: 0;
    }

    input[type="radio"]:checked+.text-radio {
      border: solid 1px #5489FF;
      background-color: #5489FF;
      color: #ffffff;
    }
  }

  .message {
    display: flex;
    min-height: 32px;
    padding: 12px;
    box-sizing: border-box;
  }

  .scroller {
    height: 100%;
  }
}

.chat-list-container {
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
</style>
